export default __webpack_public_path__ + "static/media/img11.f84bd59b.webp";